// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.square {
    display: inline-block;
    width: 75px;
    aspect-ratio: 1;
    padding: 0;
    border-radius: 10px;
    margin: 10px 5px;
}

.row {
    display: flex;
    justify-content: center;
}

.row .square p {
    margin: 0;
    width: 75px;
    height: 75px;
    text-align: center;
    line-height: 75px;
    font-family: 'Mitr', sans-serif;
    font-size: 45px;
    color: #fafaff;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/style/Row.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".square {\n    display: inline-block;\n    width: 75px;\n    aspect-ratio: 1;\n    padding: 0;\n    border-radius: 10px;\n    margin: 10px 5px;\n}\n\n.row {\n    display: flex;\n    justify-content: center;\n}\n\n.row .square p {\n    margin: 0;\n    width: 75px;\n    height: 75px;\n    text-align: center;\n    line-height: 75px;\n    font-family: 'Mitr', sans-serif;\n    font-size: 45px;\n    color: #fafaff;\n    cursor: pointer;\n    user-select: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
